export class CreateIdpGroupResponse {
    'group';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "group",
            "baseName": "group",
            "type": "IdpGroup",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CreateIdpGroupResponse.attributeTypeMap;
    }
    constructor() {
    }
}
